// Supported Languages for ELLai App
// 8 standard languages for global app store availability

export const supportedLanguages = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇺🇸',
    speechCode: 'en-US', // For Speech Recognition
    ttsVoice: 'alloy', // OpenAI TTS voice
  },
  {
    code: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    flag: '🇪🇸',
    speechCode: 'es-ES',
    ttsVoice: 'alloy',
  },
  {
    code: 'fr',
    name: 'French',
    nativeName: 'Français',
    flag: '🇫🇷',
    speechCode: 'fr-FR',
    ttsVoice: 'alloy',
  },
  {
    code: 'de',
    name: 'German',
    nativeName: 'Deutsch',
    flag: '🇩🇪',
    speechCode: 'de-DE',
    ttsVoice: 'alloy',
  },
  {
    code: 'pt',
    name: 'Portuguese',
    nativeName: 'Português',
    flag: '🇧🇷',
    speechCode: 'pt-BR',
    ttsVoice: 'alloy',
  },
  {
    code: 'ja',
    name: 'Japanese',
    nativeName: '日本語',
    flag: '🇯🇵',
    speechCode: 'ja-JP',
    ttsVoice: 'alloy',
  },
  {
    code: 'ko',
    name: 'Korean',
    nativeName: '한국어',
    flag: '🇰🇷',
    speechCode: 'ko-KR',
    ttsVoice: 'alloy',
  },
  {
    code: 'zh',
    name: 'Chinese',
    nativeName: '中文',
    flag: '🇨🇳',
    speechCode: 'zh-CN',
    ttsVoice: 'alloy',
  },
];

// Default language
export const DEFAULT_LANGUAGE = 'en';

// Get language by code
export const getLanguageByCode = (code) => {
  return supportedLanguages.find(lang => lang.code === code) || supportedLanguages[0];
};

// Get all languages as array
export const getLanguageList = () => {
  return supportedLanguages;
};

// Detect browser language and match to supported languages
export const detectBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0]; // Get just the language part (e.g., 'en' from 'en-US')

  const matched = supportedLanguages.find(lang => lang.code === langCode);
  return matched ? matched.code : DEFAULT_LANGUAGE;
};
